/*
 * Bushnell — geo "visiting from Europe?" popup.
 * Detects the visitor's country (ipinfo.io) and, for European countries,
 * invites them to the Bushnell Golf Global store. Shows at most once per
 * SNOOZE_DAYS, caches the country lookup per session, and can be dismissed.
 * No jQuery dependency.
 */
(function () {
    var STORAGE_KEY = 'bn_country_popup_seen';
    var COUNTRY_CACHE_KEY = 'bn_country_code';
    var SNOOZE_DAYS = 7;
    var IPINFO_TOKEN = '5a65b3db01853b';
    var DEFAULT_FLAG = 'https://cdn.shopify.com/s/files/1/0945/9849/6440/files/International-Flags.svg?v=1786671161';
    var DEFAULT_URL = 'https://bushnellgolfglobal.com/';

    function seenRecently() {
        try {
            var ts = parseInt(localStorage.getItem(STORAGE_KEY) || '', 10);
            return !isNaN(ts) && (Date.now() - ts) < SNOOZE_DAYS * 864e5;
        } catch (e) { return false; }
    }
    function markSeen() {
        try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) { }
    }

    function closePopup() {
        var wrap = document.getElementById('pwraper');
        var overlay = document.querySelector('.popup-overlay');
        if (wrap) wrap.classList.remove('visible');
        if (overlay) overlay.classList.remove('active');
        document.body.classList.remove('popup-lock');
        markSeen();
    }

    /** @param {string} country - ISO 3166-1 alpha-2 country code */
    function showMessage(country) {
        var wrap = document.getElementById('pwraper');
        var bodyEl = document.getElementById('popup-messege-body');
        var headEl = document.getElementById('popup-messege-head');
        var flagImg = document.getElementById('country-flag');
        var siteLink = document.getElementById('site-link');
        var overlay = document.querySelector('.popup-overlay');
        if (!wrap || !bodyEl || !headEl || !siteLink || !overlay) return;

        var messagehead = '';
        var message = '';
        var flag = DEFAULT_FLAG;
        var url = DEFAULT_URL;

        switch (country) {
            case 'IL':
            case 'GB':
                messagehead = 'Visiting from Europe?';
                message = 'You are on the USA website. Please Visit our Bushnell Golf Global Store.';
                break;
            case 'DE':
                messagehead = 'Besuch aus Europa?';
                message = 'Sie sind auf der USA-Website. Bitte besuchen Sie unseren Bushnell Golf Global Store.';
                break;
            case 'FR':
                messagehead = 'Visitez-vous depuis l\'Europe ?';
                message = 'Vous êtes sur le site américain. Veuillez visiter notre magasin mondial Bushnell Golf.';
                break;
            case 'IT':
                messagehead = 'In visita dall\'Europa?';
                message = 'Sei sul sito USA. Visita il nostro Bushnell Golf Global Store.';
                break;
            case 'PT':
                messagehead = 'Visitando da Europa?';
                message = 'Você está no site dos EUA. Por favor, visite nossa loja global Bushnell Golf.';
                break;
            case 'ES':
                messagehead = '¿Visitando desde Europa?';
                message = 'Estás en el sitio web de EE. UU. Visite nuestra tienda global de Bushnell Golf.';
                break;
            case 'PL':
                messagehead = 'Odwiedzasz z Europy?';
                message = 'Jesteś na stronie internetowej USA. Proszę odwiedzić nasz globalny sklep Bushnell Golf.';
                break;
            case 'NL':
            case 'BE':
                messagehead = 'Bezoek je vanuit Europa?';
                message = 'Je bent op de Amerikaanse website. Bezoek onze wereldwijde Bushnell Golf-winkel.';
                break;
            case 'TR':
                messagehead = 'Avrupa\'dan mı ziyaret ediyorsunuz?';
                message = 'ABD web sitesindesiniz. Lütfen Bushnell Golf Global Mağazamızı ziyaret edin.';
                break;
            case 'GR':
            case 'CY':
                messagehead = 'Επισκέπτεστε από την Ευρώπη;';
                message = 'Βρίσκεστε στον ιστότοπο των ΗΠΑ. Επισκεφθείτε το παγκόσμιο κατάστημα Bushnell Golf.';
                break;
            case 'EE':
                messagehead = 'Kas külastate Euroopast?';
                message = 'Olete USA veebisaidil. Külastage meie Bushnell Golf Global Store\'i.';
                break;
            case 'HU':
                messagehead = 'Európából látogat?';
                message = 'Az USA weboldalán van. Kérjük, látogasson el a Bushnell Golf Global Store-ba.';
                break;
            case 'HR':
                messagehead = 'Posjećujete iz Europe?';
                message = 'Nalazite se na web stranici SAD-a. Posjetite naš Bushnell Golf Global Store.';
                break;
            case 'LV':
                messagehead = 'Apmeklējat no Eiropas?';
                message = 'Jūs esat ASV vietnē. Lūdzu, apmeklējiet mūsu Bushnell Golf Global Store.';
                break;
            case 'BG':
                messagehead = 'Посещавате от Европа?';
                message = 'Вие сте на сайта на САЩ. Моля, посетете нашия глобален магазин Bushnell Golf.';
                break;
            case 'RS':
                messagehead = 'Посећујете из Европе?';
                message = 'Налазите се на веб локацији САД. Посетите нашу глобалну продавницу Bushnell Golf.';
                break;
            case 'LT':
                messagehead = 'Lankotės iš Europos?';
                message = 'Jūs esate JAV svetainėje. Prašome apsilankyti mūsų Bushnell Golf Global Store.';
                break;
            case 'MT':
                messagehead = 'Qed iżżur mill-Ewropa?';
                message = 'Int fuq il-websajt tal-Istati Uniti. Jekk jogħġbok żur il-Bushnell Golf Global Store tagħna.';
                break;
            case 'RO':
                messagehead = 'Vizitați din Europa?';
                message = 'Sunteți pe site-ul SUA. Vă rugăm să vizitați magazinul nostru global Bushnell Golf.';
                break;
            case 'BY':
                messagehead = 'Наведваеце з Еўропы?';
                message = 'Вы на сайце ЗША. Калі ласка, наведайце наш глабальны магазін Bushnell Golf.';
                break;
            case 'CA': //Canada
                messagehead = 'Visiting from Canada?';
                message = 'You are on the USA website. Please Visit our Bushnell Golf Canada Store.';
                url = 'https://www.bushnellgolfcanada.com/'; // Canada specific link
                flag = 'https://cdn.shopify.com/s/files/1/0945/9849/6440/files/canada-flag.svg?v=1786671161';
                break;
            default:
                return; // country not in the list — don't show the popup
        }

        bodyEl.textContent = message;
        headEl.textContent = messagehead;
        if (flagImg) flagImg.setAttribute('src', flag);
        siteLink.setAttribute('href', url);

        wrap.classList.add('visible');
        overlay.classList.add('active');
        document.body.classList.add('popup-lock');
        markSeen(); // snooze so it doesn't reappear on every page load
    }

    function wireControls() {
        var closeBtn = document.getElementById('popup-close');
        var stayBtn = document.getElementById('popup-stay');
        var overlay = document.querySelector('.popup-overlay');
        var siteLink = document.getElementById('site-link');
        if (closeBtn) closeBtn.addEventListener('click', closePopup);
        if (overlay) overlay.addEventListener('click', closePopup);
        if (stayBtn) stayBtn.addEventListener('click', function (e) { e.preventDefault(); closePopup(); });
        if (siteLink) siteLink.addEventListener('click', markSeen);
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                var wrap = document.getElementById('pwraper');
                if (wrap && wrap.classList.contains('visible')) closePopup();
            }
        });
    }

    function init() {
        // Don't interrupt the merchant while editing the theme.
        if (window.Shopify && window.Shopify.designMode) return;
        if (seenRecently()) return;
        wireControls();

        var cached = null;
        try { cached = sessionStorage.getItem(COUNTRY_CACHE_KEY); } catch (e) { }
        if (cached !== null) {
            showMessage(cached);
            return;
        }

        fetch('https://ipinfo.io/json?token=' + IPINFO_TOKEN)
            .then(function (r) { return r.json(); })
            .then(function (data) {
                var country = (data && data.country) || '';
                try { sessionStorage.setItem(COUNTRY_CACHE_KEY, country); } catch (e) { }
                showMessage(country);
            })
            .catch(function () { });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
